<template>
    <el-card class="page_card">
        <div slot="header" class="clearfix">
            <span>参数配置</span>
        </div>
        <el-row>
            <el-col :lg="6" :sm="12" :xs="24">
                <el-form v-model="form" ref="form" :rules="rules" label-width="180px">
                    <el-form-item label="对账时间节点(每月几号)" prop="cycle">
                        <el-input v-model="form.cycle" placeholder="请填写一个日期"></el-input>
                    </el-form-item>
                    <el-form-item label="欠款额度(元)" prop="debtQuota">
                        <el-input v-model="form.debtQuota" placeholder="请填写一个额度(元)"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button type="primary" :loading="is_post" @click="submit" plain>保 存</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </el-card>
</template>

<script>
import request from '@/utils/request'
export default {
    name: "option",
    components:{

    },
    data(){
        return {
            activeName:"basic",
            load_api:false,
            load_perm:false,
            load_role:false,
            form:{
                cycle:"",

            },
            is_post:false,
            is_ok:false,
            rules:{
                cycle:[
                    { required: true, message: '请输入对账时间节点', trigger: 'blur' },
                    {type:"number",min:1,max:28,message:"请输入1-28的数字",trigger:"blur"}
                ],
                debtQuota:[
                    { required: true, message: '请输入欠款额度', trigger: 'blur' },
                    { pattern:"/^[1-9]\d*$/",message:"请输入一个正整数",trigger:"blur" }
                ]
            }
        }
    },
    methods:{
        tab_click(s){
            this["load_"+s.name] = true;
        },
        submit(){

        },
        getData(){

        }
    },
    created(){
        this.getData();
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
